import classNames from "classnames";
import Image from "next/image";
import { Inter } from "next/font/google";

const inter = Inter({ subsets: ["latin"] });

const IMAGE_SIZE = 36;

const StarIcon = ({ size = 24 }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M22.4218 9.93237C22.3281 9.63839 22.1481 9.37946 21.905 9.18935C21.662 8.99925 21.3673 8.88681 21.0595 8.8667L15.4916 8.47705L13.4262 3.27612C13.3144 2.98859 13.1184 2.74153 12.8638 2.56732C12.6092 2.3931 12.3079 2.29986 11.9994 2.2998H11.9979C11.6899 2.30035 11.3892 2.39383 11.1352 2.56802C10.8812 2.74221 10.6856 2.989 10.5741 3.27612L8.47792 8.50708L2.94081 8.8667C2.63293 8.88681 2.33826 8.99925 2.09524 9.18935C1.85222 9.37945 1.67215 9.63839 1.57851 9.93237C1.47972 10.2305 1.473 10.5515 1.55922 10.8536C1.64544 11.1556 1.82061 11.4247 2.06191 11.6257L6.32167 15.2263L5.05458 20.2105C4.96725 20.5462 4.98331 20.9005 5.10066 21.2269C5.21801 21.5534 5.43119 21.8368 5.7123 22.04C5.98369 22.2375 6.30824 22.3487 6.6437 22.3591C6.97916 22.3696 7.30999 22.2788 7.59315 22.0986L11.9877 19.3147C11.9935 19.3103 11.9994 19.3074 12.0126 19.3147L16.7411 22.3103C16.9978 22.4743 17.298 22.557 17.6025 22.5476C17.907 22.5382 18.2016 22.4371 18.4476 22.2576C18.7024 22.0735 18.8955 21.8167 19.0019 21.521C19.1083 21.2252 19.1229 20.9043 19.0438 20.6001L17.6976 15.1553L21.9384 11.6257C22.1797 11.4247 22.3548 11.1556 22.4411 10.8536C22.5273 10.5515 22.5206 10.2305 22.4218 9.93237Z"
                fill="#FFB95A"
            />
        </svg>
    );
};

export const Testimony = ({
    text,
    username,
    imageSrc,
    glutenFreeLevel,
    stars = 0,
    variant = "default",
}) => {
    const starsArray = Array.from({ length: stars }, (_, index) => index + 1);

    return (
        <div className={classNames(inter.className, {
            "": true,
            "shrink-0 grow-1 flex flex-col justify-between dark:text-blue-900": true,
            "bg-white border-2 border-[#dce1e9] rounded-[22.33px] size-80 p-5": variant === "default",
            "bg-[#f5f7f9] text-blue-950 shadow-xl rounded-[14.75px] size-[300px] py-5 px-7": variant === "april",
        })}>
            <div>
                <div className={classNames("flex gap-0", {
                    "mb-3": variant === "default",
                    "mb-5": variant === "april",
                })}>
                    {starsArray.map((star) => (
                        <StarIcon
                            key={star}
                            size={variant === "default" ? 24 : 16}
                        />
                    ))}
                </div>
                <p className={classNames({
                    "leading-normal text-left mb-3": true,
                    "text-xl font-semibold": variant === "default",
                    "text-[15px] ": variant === "april",
                })}>
                    {text}
                </p>
            </div>
            <div className="flex gap-2 items-center text-left">
                <div className="rounded-full overflow-hidden">
                    <Image
                        src={imageSrc}
                        alt={text}
                        width={IMAGE_SIZE}
                        height={IMAGE_SIZE}
                    />
                </div>
                <div className="flex flex-col justify-center text-xs">
                    <p className="font-bold">{username}</p>
                    <p className="">{glutenFreeLevel}</p>
                </div>
            </div>
        </div>
    );
};
